/** Barra de ocupación con su porcentaje. */
export function OccupancyBar({ pct }: { pct: number | null }) {
  return (
    <span className="flex items-center gap-2">
      <span className="h-2 w-28 shrink-0 overflow-hidden rounded-full bg-gray-200">
        <span className="block h-full rounded-full bg-[#1681ba]" style={{ width: `${Math.min(100, pct ?? 0)}%` }} />
      </span>
      <span className="w-10 text-right text-xs font-semibold tabular-nums text-gray-900">{pct == null ? '—' : `${pct.toFixed(0)}%`}</span>
    </span>
  );
}

/** Aviso con el estilo de los del resto de la app. */
export function Notice({ tone, children, role = 'status' }: {
  tone: 'info' | 'warning' | 'error' | 'success';
  children: React.ReactNode;
  role?: 'status' | 'alert';
}) {
  const styles = {
    info: 'border-blue-100 bg-blue-50 text-blue-800',
    warning: 'border-amber-200 bg-amber-50 text-amber-900',
    error: 'border-red-200 bg-red-50 text-red-800',
    success: 'border-green-200 bg-green-50 text-green-800',
  } as const;
  return (
    <div role={role} className={`flex flex-wrap items-center justify-between gap-2 rounded-md border px-3 py-2 text-xs ${styles[tone]}`}>
      {children}
    </div>
  );
}

export const PRIMARY_BUTTON =
  'inline-flex items-center gap-2 rounded-md bg-[#1681ba] px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-[#126a9a] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#1681ba] focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50';

export const CARD = 'rounded-lg border border-gray-200 bg-white shadow-sm';
